export const MAX_WIDTH = 3000;
export const MAX_HEIGHT = 3000;
export const UPLOAD_LIMIT = 40;


// WEBPACK FOOTER //
// ./src/config/imageConstant.ts